"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface OtherAssetsTailoringQuestionsProps {
  onBack?: () => void;
}

const QUESTIONS: TailoringQuestion[] = [
  {
    id: "othas-1",
    question: "Are there any government incentives received by the entity during the period?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "othas-2",
    question: "Are there any accounting estimates related to other assets?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "othas-3",
    question:
      "Does the entity have material current and non-current classification of other assets in financial statements?",
    type: "radio",
    options: ["Yes", "No"],
  },
  {
    id: "othas-4",
    question: "Does the entity have material security deposits?",
    type: "radio",
    options: ["Yes", "No"],
    follow_up: {
      condition: "Yes",
      id: "othas-5",
      question: "Are we planning on sending confirmations for testing the balance?",
      type: "radio",
      options: ["Yes", "No"],
    },
  },
];

export default function OtherAssetsTailoringQuestions({ onBack }: OtherAssetsTailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Other Assets"
      title="Other Assets - Tailoring Questions"
      description="Customize the program for Other Assets."
      questions={QUESTIONS}
      onBack={onBack}
    />
  );
}


